window.orejimeConfig = Object.assign(window.orejimeConfig || {}, {
    purposes: [
        {
            id: 'content',
            title: 'Inhalte',
            purposes: [
                {
                    id: 'openstreetmap',
                    title: 'OpenStreetMap',
                    description: 'OpenStreetMap ist ein DSGVO-konformer Dienst zur Darstellung von Karten, ähnlich wie Google Maps. Wir verwenden diesen, um Veranstaltungen auf einer Karte darzustellen sowie eine Filterung nach Postleitzahl oder aktuellem Standort zu ermöglichen.',
                    default: false
                }
            ]
        }
    ],
    translations: {
        banner: {
            description: 'Hallo! Könnten wir bitte einige zusätzliche Dienste für {purposes} aktivieren? ' +
                'Du kannst deine Zustimmung später jederzeit ändern oder zurückziehen.'
        },
        modal: {
            description: 'Hier kannst du die Dienste, die wir auf dieser Website nutzen möchten steuern. ' +
                'Du hast das Sagen! Aktiviere oder deaktiviere die Dienste, wie du es für richtig hälst.'
        },
        misc: {
            updateNeeded: 'Seit deinem letzten Besuch gab es Änderungen, bitte erneuere deine Zustimmung.',
        },
        contextual: {
            description: 'Erlaube Cookies, um auf diese Funktionalität zuzugreifen.'
            //description: 'Möchtest du von {title} bereitgestellte externe Inhalte laden?'
        }
    }
})

document.querySelector('[data-open-consent]')
    .addEventListener(
        'click',
        function (e: Event) {
            e.preventDefault()
            window.orejime.prompt()
        }
    )